module.exports = __webpack_public_path__ + "img/TALLER.d5abc256.png";